import React, { forwardRef, useEffect, useState } from 'react'
import qr from '../../assets/biztrade_logo/bizQR.png'
import { useRequest } from '../../hooks/useRequest'
import classes from './POSPreview.module.css'

const POSPreview = forwardRef(({ invoiceNumber, date, clientName, orderProducts, selectedOrder }, ref) => {
    const total = selectedOrder?.Order?.payable_price || 0
    const curierId = selectedOrder?.OrderShipment?.courier_id
    const { handleFetch } = useRequest()

    const [loading, setLoading] = useState(true)
    const [curierName, setCurierName] = useState('')

    const fetchCurier = async () => {
        setLoading(true)
        try {
            const { data, isSuccess } = await handleFetch(`v1/couriers/${curierId}`)
            if (isSuccess) {
                setCurierName(data.name)
            }
        } catch (err) {
            console.log(err)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (curierId) {
            fetchCurier()
        }
    }, [curierId])

    return (
        <div className={classes.invoiceWrapper} ref={ref}>
            <div className={classes.header}>
                <p className={classes.curier}>{curierName}</p>
                <p className={classes.date}>Date: {new Date().toLocaleDateString('en-GB')}</p>
            </div>

            <div className={classes.invoice}>
                <p>Order No - {invoiceNumber}</p>
            </div>

            <div className={classes.tableWrapper}>
                <table className={classes.customTable}>
                    <tbody>
                        <tr>
                            <td className={classes.fullRow} colSpan={2}>
                                {selectedOrder?.OrderShipment?.district + selectedOrder?.OrderShipment?.district !== ''
                                    ? ','
                                    : '' + selectedOrder?.OrderShipment?.area}
                            </td>
                        </tr>
                        <tr>
                            <td>{selectedOrder?.OrderShipment?.detail_address}</td>
                            <td>N/A</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className={classes.invoiceDetails}>
                <div className={classes.leftDetails}>
                    <p>
                        <strong>Client:</strong> {clientName}
                    </p>
                    <p>
                        <strong>Phone:</strong> {selectedOrder?.OrderShipment?.customer_phone}
                    </p>
                    <p>
                        <strong>Address:</strong> {selectedOrder?.OrderShipment?.detail_address}
                    </p>
                    <p className={classes.totalPrice}>{total} BDT</p>
                </div>

                <div className={classes.rightDetails}>
                    <p>
                        <strong>Weight:</strong> {selectedOrder?.OrderShipment?.delivery_weight} kg
                    </p>
                </div>
            </div>

            <div className={classes.barcodeWrapper}>
                <div className={classes.bizQR}>
                    <img src={qr} alt="" />
                </div>
                <div className={classes.sellerInfo}>
                    <label htmlFor="seller">{selectedOrder?.Seller?.page_name}</label>
                    <textarea id="seller" name="seller" placeholder="N/A" />
                </div>
            </div>

            <div className={classes.footer}>
                <p className={classes.footerText}>Powered by Biztrade</p>
            </div>
        </div>
    )
})

export default POSPreview
